import ContactForm from '../../components/ContactForm';
import Layout from '../../components/Layout';
import SectionHeading from '../../components/SectionHeading';
import ServiceCard from '../../components/ServiceCard';
import { useSiteContent } from '../../content/ContentContext';

export default function ServicesPage() {
  const {
    content: { serviceGroups, site },
  } = useSiteContent();

  return (
    <Layout>
      <section className="bg-[#123018] text-white">
        <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
          <p className="mb-4 text-sm font-bold uppercase tracking-[0.18em] text-[#7dff45]">Services</p>
          <h1 className="max-w-3xl text-4xl font-black tracking-tight sm:text-5xl">{site.servicesPageTitle}</h1>
          <p className="mt-5 max-w-3xl text-lg leading-8 text-white/85">{site.servicesPageDescription}</p>
        </div>
      </section>

      {serviceGroups.map((group) => (
        <section key={group.title} className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
          <SectionHeading title={group.title} />
          <div className="grid gap-8 md:grid-cols-2 xl:grid-cols-3">
            {group.items.map((service) => (
              <ServiceCard key={service.name} {...service} />
            ))}
          </div>
        </section>
      ))}

      <section className="bg-slate-50">
        <div className="mx-auto max-w-5xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24">
          <SectionHeading
            eyebrow="Get a Quote"
            title="Tell us what service you need"
            description="Use the form below to request a free estimate for residential or commercial work."
            center
          />
          <ContactForm />
        </div>
      </section>
    </Layout>
  );
}
